export const VOUCHER_ACTIONS = {
    NOT_ISSUED : 0,
    ISSUED : 1,
    INVOICED : 2,
}